import {Pipe, PipeTransform} from '@angular/core';
import {StringUtils} from '../../util/string-utils/string.util';

@Pipe({
    name: 'kebabCase',
    standalone: true,
})
export class KebabCasePipe implements PipeTransform {
    public transform(originalString: string): string {
        return StringUtils.transformToKebabCase(originalString);
    }
}
